// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

export interface GeneratedAnalyticsMetadataModalDismiss {
  action: 'dismiss';
  detail: {
    label: string;
  };
}

export interface GeneratedAnalyticsMetadataModalComponent {
  name: 'awsui.Modal';
  label: string;
}
